import { computed, nextTick, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { ModalUnsafeExitStates } from '@/models/modal/modal.enum';
import { IRouter } from '@/models/router/router.interface';
import * as Ladda from 'ladda';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class UnsafeExitModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	public loadingButton: Ref<HTMLButtonElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	public saveInProgress = computed((): boolean => {
		return this.modalUnsafeExitState.value === ModalUnsafeExitStates.SAVING;
	});

	public isSaveEnabled = computed((): boolean => {
		return store.getters.isSaveEnabled();
	});

	private modalUnsafeExitState = computed((): ModalUnsafeExitStates => {
		return store.getters.modalUnsafeExitState();
	});

	private router = computed((): IRouter => {
		return store.getters.router();
	});

	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	public closeModal(): void {
		store.mutations.setModalUnsafeExitState(ModalUnsafeExitStates.INACTIVE);
	}

	public async saveAndNavigate(): Promise<void> {
		store.mutations.setModalUnsafeExitState(ModalUnsafeExitStates.SAVING);
		void this.triggerLoadingAnimation();
		await campaignPresenter.saveCampaignDetails();
		if (!this.router.value.next) {
			return;
		}

		store.mutations.setCurrentRoute(this.router.value.next);
		this.closeModal();
	}

	public revertAndNavigate(): void {
		store.mutations.revertToOriginalCampaignDetails();
		if (!this.router.value.next) {
			return;
		}

		store.mutations.setCurrentRoute(this.router.value.next);
		this.closeModal();
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'UnsafeExitModalWrapper',
			destroyOnClose: true,
			onClose: this.closeModal.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}

	private async triggerLoadingAnimation(): Promise<void> {
		await nextTick();

		if (!this.loadingButton.value) {
			return;
		}

		Ladda.create(this.loadingButton.value).start();
	}
}
